// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__XxWDz","info":"Contact_info__X+aNY"};